import { useAppStore } from '@/stores/app'

export const isAuthenticated = (): boolean => {
    const appStore = useAppStore()

    return appStore.isLoggedIn()
}

/*
 * Where to go after signing in: the page that sent somebody here (`?redirect=`), but only an
 * address inside this console, never another site.
 */
export const safeRedirect = (value: unknown): string | null => {
    if (typeof value !== 'string') return null
    if (!value.startsWith('/') || value.startsWith('//') || value.startsWith('/\\')) return null
    if (value.startsWith('/login')) return null

    return value
}
